import { Divider } from '@mui/material'
import {
  FooterWrapper,
  FooterContent,
  FooterLink,
  FooterSeparator,
  FooterText,
} from './footer-styles'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined'

export default function Footer() {
  return (
    <FooterWrapper component='footer'>
      <Divider />
      <FooterContent>
        <FooterLink href='/about' underline='none'>
          <InfoOutlinedIcon fontSize='small' />
          About
        </FooterLink>
        <FooterSeparator>|</FooterSeparator>
        <FooterLink href='/guide' underline='none'>
          <MenuBookOutlinedIcon fontSize='small' />
          Guide
        </FooterLink>
        <FooterSeparator>|</FooterSeparator>
        <FooterLink href='/help' underline='none'>
          <HelpOutlineIcon fontSize='small' />
          Help
        </FooterLink>
        <FooterSeparator>|</FooterSeparator>
        <FooterLink
          href='https://www.themoviedb.org/'
          target='_blank'
          underline='none'
        >
          <ComputerOutlinedIcon fontSize='small' />
          Source: TMDB
        </FooterLink>
      </FooterContent>
      <FooterText>
        &copy; {new Date().getFullYear()} Movieception. All rights reserved.
      </FooterText>
    </FooterWrapper>
  )
}
